import { LayoutBreakpointSizes } from "@1js/window-util/lib/WindowUtil/layoutBreakpointTypings"; // Deep import is needed because WindowUtils.ts has a root-level initialization call that cancels tree shaking

export function isMobile() {
  return isAndroid() || isIPhone() || isIPad();
}

function hasTouchPoints(): boolean {
  return navigator.maxTouchPoints > 0;
}

export function isMac(): boolean {
  return navigator.userAgent.indexOf("Macintosh") >= 0;
}

export function isSafari(): boolean {
  // Using deprecated API because suggested alternative (userAgentData) is not cross-platform
  return /apple/i.test(navigator.vendor);
}

export function isFirefox() {
  return /firefox/i.test(navigator.userAgent);
}

// New Edge contains Edg/ instead of Edge/
// New Edge example UA: Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 ...
// ...(KHTML, like Gecko) Chrome/80.0.3987.122 Safari/537.36 Edg/80.0.361.50
export function isLegacyEdge() {
  return navigator.userAgent.indexOf("Edge/") >= 0;
}

export function isIE() {
  return navigator.userAgent.indexOf("Trident") >= 0;
}

export function isChromeBased() {
  return !isLegacyEdge() && navigator.userAgent.indexOf("Chrome/") >= 0;
}

export function isElectron() {
  return navigator.userAgent.indexOf("Electron/") >= 0 && isChromeBased();
}

export function isTouchEnabled() {
  return isMobile() || hasTouchPoints();
}

/** Align small device width with layoutBreakpointSizes since they
 * are the same and we should have a consistent breakpoint story for
 * screen sizes.
 */
export function getSmallDeviceWidth() {
  return LayoutBreakpointSizes.Small.Portrait;
}

/** This height was originally determined by the shy ribbon for small screens
 * but it works for other scenarios so we are sharing it.
 */
export function getSmallDeviceHeight() {
  return 569;
}

export function isSmallDevice() {
  return (
    window.innerWidth <= getSmallDeviceWidth() ||
    window.innerHeight <= getSmallDeviceHeight()
  );
}

/**
 * This will be used to determine shy ribbon for very small screens
 */
export function isVerySmallDevice() {
  return window.innerWidth <= 320 || window.innerHeight <= 256;
}

export function prefersDarkMode() {
  return (
    window &&
    window.matchMedia &&
    window.matchMedia("(prefers-color-scheme: dark)").matches
  );
}

export function supportsResizeAndIntersectionObserver() {
  return !!window.ResizeObserver && !!window.IntersectionObserver;
}

export function isAndroid(): boolean {
  return navigator.userAgent.indexOf("Android") >= 0;
}

export function isIPhone(): boolean {
  return navigator.userAgent.indexOf("iPhone") >= 0;
}

export function isIPad(): boolean {
  /*
  Safari on iPadOS 13 defaults to a desktop browsing experience,
  achieved by sending a UserAgent string that matches Safari on MacOS.
  Our IPad checks look for the string "iPad" in the UA,
  which fails to identify an iPad on the iPadOS 13.

  Currently, Apple doesn't ship a touch screen Mac,
  so we can infer that we're on an iPad if it's not an iPhone but supports touch.
  */
  return (
    navigator.userAgent.indexOf("iPad") >= 0 ||
    (isMac() && hasTouchPoints() && !isIPhone())
  );
}

export function isMacOrIPad(): boolean {
  return isMac() || isIPad();
}
